function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "door-open-solid",
  d: "M12.917,4l-.062.021L7.521,5.271,7,5.4V18.9l.542.083,5.333,1,.063.021h1.4V4Zm2.75,1.333V6.667h2V17.333h-2v1.333H19V5.333ZM13,5.354V18.667l-4.667-.875V6.438Zm-1.1,5.979c-.245,0-.458.3-.458.667s.214.667.458.667.437-.3.437-.667S12.141,11.333,11.9,11.333Z",
  transform: "translate(-7 -4)"
});

var SvgDoorOpenSolid = function SvgDoorOpenSolid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDoorOpenSolid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/door-open-solid.ce324318.svg";
export { ForwardRef as ReactComponent };